import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import { useUpdateURLSearchParams } from '@/hooks/useQuery'
import { useUpdateAnswerById } from '@/queries/answers/answerSignature/useUpdateAnswerById'
import { invalidateLoadResponses } from '@/queries/responses/useLoadResponse'
import Modal from '@/ui/Modal'

import { TextEditor } from '../TextEditor'

type Props = {
  value: string
  answer_id: string
  setAnswer: (answer: string) => void
  onCancel: () => void
}

export const SummaryAIAnswerModal = ({
  value,
  answer_id,
  setAnswer,
  onCancel,
}: Props) => {
  const { responseId } = useParams<{ responseId: string }>()
  const { updateAnswerById, isLoading } = useUpdateAnswerById()

  const updateParams = useUpdateURLSearchParams()
  const handleSave = async () => {
    try {
      await updateAnswerById({
        id: answer_id,
        answer_raw: value,
      })
      await invalidateLoadResponses(responseId)
      toast.info('Summary AI answer updated')
      updateParams(['edit_summary_ai_answer', undefined])
    } catch (error) {
      toast.error('Error updating summary AI answer')
    }
  }

  return (
    <Modal
      open
      cancelButtonProps={{ loading: isLoading }}
      classNames={{ mask: 'backdrop-blur' }}
      okButtonProps={{ loading: isLoading }}
      okText="Save"
      onCancel={() => {
        updateParams(['edit_summary_ai_answer', undefined])
        onCancel?.()
      }}
      onOk={handleSave}
      title="Edit Summary AI Answer"
    >
      <TextEditor
        className="text-sm"
        disabled={isLoading}
        minHeight={100}
        onChange={setAnswer}
        tools={['bold', 'italic', 'underline', 'strike', 'bulletList']}
        value={value}
      />
    </Modal>
  )
}
